var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{staticClass:"mr-1 s-menu-pc__list-icon"},[_vm._v("mdi-hand-pointing-right")]),_c('h1',{staticClass:"app-title-dark"},[_vm._v(_vm._s(_vm.smsToolTip))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }